<template>
  <component
    :is="el"
    class="c-text"
    :class="`c-text--${variant}`"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
interface Props {
  variant?:
    | 'xs'
    | 'sm'
    | 'md'
    | 'lg'
    | 'system-xxs'
    | 'system-xs'
    | 'system-sm'
    | 'system-md'
    | 'system-xxs-semibold'
    | 'system-xs-semibold'
    | 'system-sm-semibold'
    | 'system-md-semibold'
    | 'system-xxs-bold'
    | 'system-xs-bold'
    | 'system-sm-bold'
    | 'system-md-bold'
  el?: 'p' | 'span' | 'li' | 'b' | 'i' | 'u' | 'strong'
}

withDefaults(defineProps<Props>(), {
  variant: 'md',
  el: 'p',
})
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CText',
})
</script>
